import type { WorkflowPreparationSettingsPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import WorkflowAutomaticSourceView from '@UI/Store/OrganizationWorkflows/Views/WorkflowAutomaticSourceView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * What a preparation of a group accepts: the kinds of elements and the documents reused automatically.
 */
class WorkflowPreparationSettingsView {
	readonly acceptsInterviews: boolean;
	readonly acceptsNotes: boolean;
	readonly acceptsDocuments: boolean;
	readonly requiresValidationBeforeNext: boolean;
	readonly automaticSources: readonly WorkflowAutomaticSourceView[];

	constructor(payload: WorkflowPreparationSettingsPayload) {
		this.acceptsInterviews = payload.acceptsInterviews;
		this.acceptsNotes = payload.acceptsNotes;
		this.acceptsDocuments = payload.acceptsDocuments;
		this.requiresValidationBeforeNext = payload.requiresValidationBeforeNext;
		this.automaticSources = payload.automaticSources.map(
			(source) => new WorkflowAutomaticSourceView(source),
		);

		Object.freeze(this);
	}
}

export default WorkflowPreparationSettingsView;
